function initialState () {
	return {scene: {}};
}

export default {
	state: initialState,
	getters: {
		scene: state => state.scene
	},

	mutations: {
		scene(state, sceneObj) {
			state.scene = JSON.parse(JSON.stringify(sceneObj));
		},

		updateExperienceTitle(state, title) {
			state.scene.title = title;
		},

		addSceneNode(state, nodeObj) {
			state.scene.nodes.push(nodeObj);
		},

		saveSceneNode(state, nodeObj) {
			let nodeIndex = null;
			let objectExists = state.scene.nodes.filter(function(el, index){
				if (el.id == nodeObj.id) {nodeIndex = index;}
				return el.id == nodeObj.id;
			})[0];
			console.log(objectExists);
			console.log(nodeIndex);
			if (objectExists) {
				state.scene.nodes.splice(nodeIndex, 1, nodeObj);
			} else {
				state.scene.nodes.push(nodeObj);
			}
		},

		deleteSceneNode(state, nodeId) {
			state.scene.nodes = state.scene.nodes.filter((node) => {
				return node.id !== nodeId;
			});
			state.scene.links = state.scene.links.filter((link) => {
				return link.from !== nodeId && link.to !== nodeId
			});
		},

		updateSceneNodePosition(state, payload) {
			state.scene.nodes[payload.nodeIndex].x = payload.left;
			state.scene.nodes[payload.nodeIndex].y = payload.top;
		},

		addSceneLink(state, linkObj) {
			state.scene.links.push(linkObj);
		},

		deleteSceneLink(state, linkId) {
			state.scene.links = state.scene.links.filter((item) => {
					return item.id !== linkId;
			});
		},

		resetScene (state) {
			Object.assign(state, initialState());
		}
	},

	actions: {
		editScene({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('scene', payload.sceneObj);
				resolve();
			});
		},

		saveScene({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('saveScene', payload.sceneObj);
				resolve();
			});
		},

		deleteScene({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('deleteScene', payload.sceneObj);
				resolve();
			});
		},

		updateExperienceTitle({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('updateExperienceTitle', payload.title);
				resolve();
			});
		},

		addSceneNode({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('addSceneNode', payload.newNode);
				resolve();
			});
		},

		saveSceneNode({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('saveSceneNode', payload.nodeObj);
				resolve();
			});
		},

		deleteSceneNode({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('deleteSceneNode', payload.nodeId);
				resolve();
			});
		},

		updateSceneNodePosition({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('updateSceneNodePosition', payload);
				resolve();
			});
		},

		addSceneLink({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('addSceneLink', payload.newLink);
				resolve();
			});
		},

		deleteSceneLink({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('deleteSceneLink', payload.linkId);
				resolve();
			});
		},
		
		resetScene ({commit}) {
			return new Promise((resolve, reject) => {
				commit('resetScene');
				resolve();
			});
		}
	}
}